export default "__VITE_ASSET__CHZatDg4__"